module.exports = __webpack_public_path__ + "img/image31.843b5cc1.jpg";